import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import differenceInDays from 'date-fns/differenceInDays';
import { useStore } from '../../../../../../store';
import Heading from '../../../../../../generic-components/Heading';
import { STYLES } from '../../consts';
import { LiliCheckbox, LiliCheckboxType } from '../../../../../../DesignSystem/LiliCheckbox/LiliCheckbox';

export const PaymentReminder = () => {
  const billData = useStore(state => state.billData);
  const setBillData = useStore(state => state.setBillData);
  const { t } = useTranslation();
  const isReminderOptionEnabled = useMemo(() => {
    if (!billData?.dueDate) return false;
    return differenceInDays(new Date(billData.dueDate), new Date()) >= 3;
  }, [billData.dueDate]);

  const handleCheckboxChange = (checked: boolean) => {
    setBillData({
      ...billData,
      paymentReminderData: { ...billData.paymentReminderData, paymentReminderEnabled: checked },
    });
  };

  return (
    <div className={STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.WRAPPER}>
      <div className={STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.HEADER_WRAPPER}>
        <LiliCheckbox
          id='paymentReminderEnabledCheckbox'
          type={isReminderOptionEnabled ? LiliCheckboxType.REGULAR : LiliCheckboxType.DISABLED}
          checked={isReminderOptionEnabled ? (billData.paymentReminderData?.paymentReminderEnabled || false) : false}
          onCheckedChange={handleCheckboxChange}
        />
        <Heading title={t('CREATE_BILL.FORM.PAYMENT_REMINDER')} className={`${isReminderOptionEnabled ? STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.TITLE : STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.TITLE_DISABLED}`} />
      </div>
      <div className='pl-6'>
        <Heading title={t('CREATE_BILL.FORM.PAYMENT_REMINDER_SUB')} className={`${isReminderOptionEnabled ? STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.SUB_TITLE : STYLES.CREATE_BILL_BODY.PAYMENT_REMINDER.SUB_TITLE_DISABLED}`} />
      </div>
    </div>
  );
};
